import type * as SchemaTypes from '../../apolloClient.types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FetchCurrentUserQueryVariables = SchemaTypes.Exact<{ [key: string]: never; }>;


export type FetchCurrentUserQuery = (
  { __typename: 'Query' }
  & { currentUser?: SchemaTypes.Maybe<(
    { __typename: 'User' }
    & Pick<SchemaTypes.User, 'id'>
    & CurrentUserFragment
  )> }
);

export type CurrentUserFragment = (
  { __typename: 'User' }
  & Pick<SchemaTypes.User, 'id' | 'email' | 'organizationRole'>
  & { groups: Array<(
    { __typename: 'UserGroup' }
    & Pick<SchemaTypes.UserGroup, 'id' | 'name' | 'role'>
  )> }
);

export const CurrentUserFragmentDoc = /*#__PURE__*/ gql`
    fragment CurrentUser on User {
  id
  email
  groups {
    id
    name
    role
  }
  organizationRole
}
    `;
export const FetchCurrentUserDocument = /*#__PURE__*/ gql`
    query FetchCurrentUser {
  currentUser {
    id
    ...CurrentUser
  }
}
    ${CurrentUserFragmentDoc}`;

/**
 * __useFetchCurrentUserQuery__
 *
 * To run a query within a React component, call `useFetchCurrentUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchCurrentUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchCurrentUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchCurrentUserQuery(baseOptions?: Apollo.QueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
      }
export function useFetchCurrentUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
        }
export function useFetchCurrentUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>(FetchCurrentUserDocument, options);
        }
export type FetchCurrentUserQueryHookResult = ReturnType<typeof useFetchCurrentUserQuery>;
export type FetchCurrentUserLazyQueryHookResult = ReturnType<typeof useFetchCurrentUserLazyQuery>;
export type FetchCurrentUserSuspenseQueryHookResult = ReturnType<typeof useFetchCurrentUserSuspenseQuery>;
export type FetchCurrentUserQueryResult = Apollo.QueryResult<FetchCurrentUserQuery, FetchCurrentUserQueryVariables>;